'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var upgradeProducts = exports.upgradeProducts = {
  // We're supporting this product until INBOUND then this upgrade product
  // will be removed since components will be using the new SKUs
  SALES_PRO: 'sales-pro',
  SALES_STARTER: 'sales-starter',
  SALES_PROFESSIONAL: 'sales-professional',
  SALES_ENTERPRISE: 'sales-enterprise',

  MARKETING_STARTER: 'marketing-starter',
  MARKETING_STARTER_EMAIL: 'marketing-starter-email',
  MARKETING_BASIC: 'marketing-basic',
  MARKETING_PRO: 'marketing-pro',
  MARKETING_ENTERPRISE: 'marketing-enterprise',

  SERVICE_STARTER: 'service-starter',
  SERVICE_PROFESSIONAL: 'service-professional',
  SERVICE_ENTERPRISE: 'service-enterprise',

  STARTER_CONTACTS: 'starter-contacts',

  ADS: 'ads',
  ADS_CAPACITY: 'ads-capacity',
  WEBSITE: 'website',
  REPORTING: 'reporting',
  DEDICATED_IP: 'dedicated-ip',
  TRANSACTIONAL_EMAIL: 'transactional-email',
  ADDITIONAL_ACCOUNT: 'additional-account',
  BRAND_DOMAIN: 'brand-domain',

  DESIGNATED_TECHNICAL_SUPPORT: 'designated-technical-support',
  IN_PERSON_TRAINING: 'in-person-training',
  STARTER_KIT: 'starter-kit',
  SALES_PROFESSIONAL_ONBOARDING: 'sales-professional-onboarding',
  SERVICE_PROFESSIONAL_ONBOARDING: 'service-professional-onboarding',
  INBOUND_CONSULTING_BLOCK: 'inbound-consulting-block',
  TECHNICAL_CONSULTING_BLOCK: 'technical-consulting-block',
  QUICK_START_CONSULTATION: 'quick-start-consultation',

  // Used only for free product activation
  CMS: 'cms',
  CRM: 'crm',
  SALES_FREE: 'sales-free',
  MARKETING_FREE: 'marketing-free',
  SERVICE_FREE: 'service-free',

  // Used for partner-program inquiries
  PARTNER_PROGRAM: 'partner-program',

  // For growth-suite purchases
  SUITE_STARTER: 'suite-starter',
  SUITE_PROFESSIONAL: 'suite-professional',
  SUITE_ENTERPRISE: 'suite-enterprise',

  // Used only for bundled enterprise trial
  ENTERPRISE_TRIAL: 'enterprise-trial',

  // Used when feature can be unlocked by any enterprise SKU
  ENTERPRISE: 'enterprise',

  BUNDLE: 'bundle',

  // Used to designate upgrades not associated with a product
  // ONLY FOR USE WITH UIContactSalesButton, see PR#384
  GENERAL: 'general'
};

var freeProducts = exports.freeProducts = [upgradeProducts.CRM, upgradeProducts.CMS, upgradeProducts.SALES_FREE, upgradeProducts.MARKETING_FREE, upgradeProducts.SERVICE_FREE];

var supportedProductExplorationModals = exports.supportedProductExplorationModals = [upgradeProducts.SALES_STARTER, upgradeProducts.SALES_PROFESSIONAL, upgradeProducts.SALES_ENTERPRISE, upgradeProducts.MARKETING_PRO, upgradeProducts.SERVICE_PROFESSIONAL];

var upgradeProductValues = exports.upgradeProductValues = Object.keys(upgradeProducts).map(function (key) {
  return upgradeProducts[key];
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/properties/upgradeProducts.js
// module id = 52
// module chunks = 3 4 5